var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.erro)?_c('div',[_c('SemPermissao')],1):_vm._e(),(!_vm.erro)?[_c('StatusForm',{attrs:{"status":null}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }